/* DISPLAY HELPERS */
$displays: 'block', 'inline', 'inline-block', 'none', 'contents';
@each $display in $displays {
  .d-#{$display} {
    display: #{$display};
  }
}

/* SIZE HELPERS */
@for $i from 0 through 100 {
  .w-#{$i} {
    width: #{$i}#{"%"};
  }
}

/* GAP HELPERS */
@for $i from 0 through 5 {
  .gap-#{$i} {
    gap: calc(var(--spacer) * #{$i});
  }
}

/* MARGINS HELPERS */
$size: '1', '2', '3', '4', '5', '6', '7', '8', '9', '10';
@each $marginRight in $size {
  .mr-#{$marginRight} {
    margin-right: calc(var(--spacer) * #{$marginRight});
  }

  .-mr-#{$marginRight} {
    margin-right: calc(-1 * var(--spacer) * #{$marginRight});
  }
}
@each $marginLeft in $size {
  .ml-#{$marginLeft} {
    margin-left: calc(var(--spacer) * #{$marginLeft});
  }

  .-ml-#{$marginLeft} {
    margin-left: calc(-1 * var(--spacer) * #{$marginLeft});
  }
}
@each $marginTop in $size {
  .mt-#{$marginTop} {
    margin-top: calc(var(--spacer) * #{$marginTop});
  }

  .-mt-#{$marginTop} {
    margin-top: calc(-1 * var(--spacer) * #{$marginTop});
  }
}
@each $marginBottom in $size {
  .mb-#{$marginBottom} {
    margin-bottom: calc(var(--spacer) * #{$marginBottom});
  }

  .-mb-#{$marginBottom} {
    margin-bottom: calc(-1 * var(--spacer) * #{-$marginBottom});
  }
}

/* PADDING HELPERS */
$paddings: 5; // padding values from 8 to 40px, i.e. 8, 16, 24, 32 etc
@for $i from 1 through $paddings {
  .px-#{$i} {
    padding-left: calc(#{$i} * var(--spacer));
    padding-right: calc(#{$i} * var(--spacer));
  }

  .pl-#{$i} {
    padding-left: calc(#{$i} * var(--spacer));
  }

  .pr-#{$i} {
    padding-right: calc(#{$i} * var(--spacer));
  }

  .py-#{$i} {
    padding-top: calc(#{$i} * var(--spacer));
    padding-bottom: calc(#{$i} * var(--spacer));
  }

  .pt-#{$i} {
    padding-top: calc(#{$i} * var(--spacer));
  }

  .pb-#{$i} {
    padding-bottom: calc(#{$i} * var(--spacer));
  }
}

/* FONT SIZE HELPER */
$smallFontSizes: '9', '10', '11', '12', '13';
$fontSizes: '14', '15', '16', '17', '18', '19', '20', '24', '32', '48';
@each $fontSize in $smallFontSizes {
  .fs-#{$fontSize} {
    font-size: calc(#{$fontSize}px + var(--dynamic-small-font-size-changer));
  }
}

@each $fontSize in $fontSizes {
  .fs-#{$fontSize} {
    font-size: calc(#{$fontSize}px + var(--dynamic-font-size-changer));
  }
}


/* LAYOUT MIXINS */

// Generate a 12 columns dynamicColumnLayout
$columns: 12;
@for $i from 2 through $columns {
  .layout-#{$i}-columns {
    display: grid;
    grid-template-columns: repeat(#{$i}, 1fr);
    grid-gap: calc(2 * var(--spacer));
  }
}


.pointer {
  cursor: pointer;
}
